import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});